/* Overlooked motion layer (Framer Motion engine, loaded as window.Motion).
   Scroll reveals, staggers, hover polish, hero parallax and header scroll state.
   Animation only. Respects prefers-reduced-motion.
   Outside product pages a lighter native path runs (no library), and button and card
   hover/press are handled in CSS (restyle.css). Product pages keep the original timing. */
(function () {
  'use strict';

  var root = document.documentElement;
  var M = window.Motion;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var mainEl = document.querySelector('main[data-template]');
  var lite = !mainEl || mainEl.getAttribute('data-template') !== 'product';

  function ready() {
    root.classList.remove('mo-pending');
  }

  if (reduced) {
    ready();
    return;
  }

  /* ---------- Lite path: everything except product pages ----------
     Native IntersectionObserver + Web Animations, no library download.
     The first section (the hero) is never hidden, so it paints immediately. */
  if (lite) {
    runLite();
    return;
  }

  if (!M || !M.animate) {
    ready();
    return;
  }

  var animate = M.animate;
  var inView = M.inView;
  var hover = M.hover;
  var press = M.press;
  var scroll = M.scroll;

  var EASE = [0.22, 1, 0.36, 1];
  var SPRING = { type: 'spring', stiffness: 380, damping: 28 };
  var isMobile = window.matchMedia('(max-width: 749px)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  var UNIT = [
    'h1', 'h2', 'h3', 'h4', 'p', '.rte', '.button', '.grid__item', '.card-wrapper',
    '[class*="__heading"]', '[class*="__title"]', '[class*="__desc"]', '[class*="__body"]',
    '[class*="__card"]', '[class*="__button"]', '[class*="__item"]', '[class*="__step"]'
  ].join(',');

  var SKIP_ANCESTOR = 'header, .section-header, form, product-info, cart-items, cart-drawer, ' +
    'dialog, [role="dialog"], .scroll-trigger, [aria-hidden="true"], .visually-hidden, [hidden], ' +
    'style, script, template, .announcement-bar';

  function isUnit(el) {
    if (el.closest(SKIP_ANCESTOR)) return false;
    if (!el.getClientRects().length) return false;
    if (window.getComputedStyle(el).transform !== 'none') return false;
    return true;
  }

  function outermost(list) {
    return list.filter(function (el) {
      return !list.some(function (other) {
        return other !== el && other.contains(el);
      });
    });
  }

  function runLite() {
    var UNIT_L = [
      'h1', 'h2', 'h3', 'h4', 'p', '.rte', '.button', '.grid__item', '.card-wrapper',
      '[class*="__heading"]', '[class*="__title"]', '[class*="__desc"]', '[class*="__body"]',
      '[class*="__card"]', '[class*="__button"]', '[class*="__item"]', '[class*="__step"]'
    ].join(',');
    var SKIP_L = 'header, .section-header, form, product-info, cart-items, cart-drawer, ' +
      'dialog, [role="dialog"], .scroll-trigger, [aria-hidden="true"], .visually-hidden, [hidden], ' +
      'style, script, template, .announcement-bar';
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var count = 0;
    var frame = 0;
    var pending = [];

    function delay() {
      var d = Math.min(count, 5) * 45;
      count += 1;
      if (!frame) {
        frame = requestAnimationFrame(function () {
          count = 0;
          frame = 0;
        });
      }
      return d;
    }

    function show(el) {
      if (el.__obShown) return;
      el.__obShown = true;
      if (el.animate) {
        el.animate(
          [
            { opacity: 0, transform: 'translateY(' + (mobile ? 10 : 12) + 'px)', filter: 'blur(4px)' },
            { opacity: 1, transform: 'none', filter: 'blur(0px)' }
          ],
          { duration: 450, delay: delay(), easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'backwards' }
        );
      }
      el.style.removeProperty('opacity');
    }

    var io = 'IntersectionObserver' in window
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            io.unobserve(entry.target);
            show(entry.target);
          });
        }, { rootMargin: '0px 0px -6% 0px' })
      : null;

    if (!designMode && io) {
      var sections = document.querySelectorAll('main .shopify-section:not(:first-child), .shopify-section-group-footer-group');
      Array.prototype.forEach.call(sections, function (section) {
        if (section.querySelector('product-info, cart-items')) return;
        var list = Array.prototype.slice.call(section.querySelectorAll(UNIT_L)).filter(function (el) {
          if (el.closest(SKIP_L)) return false;
          if (!el.getClientRects().length) return false;
          return window.getComputedStyle(el).transform === 'none';
        });
        list.filter(function (el) {
          return !list.some(function (other) {
            return other !== el && other.contains(el);
          });
        }).forEach(function (el) {
          el.style.opacity = '0';
          pending.push(el);
          io.observe(el);
        });
      });
    }

    var header = document.querySelector('.header-wrapper');
    var scrolled = false;
    var ticking = false;

    function onScroll() {
      ticking = false;
      if (header) {
        var next = window.scrollY > 12;
        if (next !== scrolled) {
          scrolled = next;
          header.classList.toggle('ob-scrolled', next);
        }
      }
      if (pending.length && window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 4) {
        pending.forEach(function (el) {
          if (el.getBoundingClientRect().top < window.innerHeight) {
            if (io) io.unobserve(el);
            show(el);
          }
        });
      }
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(onScroll);
        }
      },
      { passive: true }
    );
    onScroll();
    ready();
  }

  /* ---------- Scroll reveal with stagger ---------- */
  var batch = 0;
  var batchFrame = 0;

  function nextDelay() {
    var delay = lite ? Math.min(batch, 5) * 0.045 : Math.min(batch, 6) * 0.07;
    batch += 1;
    if (!batchFrame) {
      batchFrame = requestAnimationFrame(function () {
        batch = 0;
        batchFrame = 0;
      });
    }
    return delay;
  }

  var waiting = [];

  function reveal(el) {
    el.style.opacity = '0';
    var fired = false;
    var stop;

    function fire() {
      if (fired) return;
      fired = true;
      if (stop) stop();
      var keyframes = lite
        ? { opacity: [0, 1], y: [isMobile.matches ? 10 : 12, 0], filter: ['blur(4px)', 'blur(0px)'] }
        : { opacity: [0, 1], y: [isMobile.matches ? 14 : 20, 0] };
      var controls = animate(
        el,
        keyframes,
        { duration: lite ? 0.45 : 0.9, ease: EASE, delay: nextDelay() }
      );
      var clean = function () {
        setTimeout(function () {
          el.style.removeProperty('opacity');
          el.style.removeProperty('transform');
          el.style.removeProperty('filter');
        }, 60);
      };
      if (controls && controls.then) controls.then(clean, clean);
    }

    waiting.push({ el: el, fire: fire });
    stop = inView(el, fire, { margin: '0px 0px -6% 0px' });
  }

  /* Elements at the very bottom of the page can never scroll past the trigger margin,
     so reveal anything still visible once the reader reaches the end. */
  function initEndOfPageCatch() {
    var ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          if (window.innerHeight + window.scrollY < document.documentElement.scrollHeight - 4) return;
          waiting.forEach(function (item) {
            if (item.el.getBoundingClientRect().top < window.innerHeight) item.fire();
          });
        });
      },
      { passive: true }
    );
  }

  function initReveals() {
    var sections = document.querySelectorAll('main .shopify-section, .shopify-section-group-footer-group');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.querySelector('product-info, cart-items')) return;
      var units = outermost(Array.prototype.slice.call(section.querySelectorAll(UNIT)).filter(isUnit));
      units.forEach(reveal);
    });
  }

  /* ---------- Hover and press polish ---------- */
  function initHover() {
    if (!canHover) return;

    if (!lite) {
      Array.prototype.forEach.call(
        document.querySelectorAll('.button:not(.button--tertiary):not([disabled]):not(.shopify-payment-button__button)'),
        function (el) {
          hover(el, function () {
            animate(el, { scale: 1.02, y: -1 }, SPRING);
            return function () {
              animate(el, { scale: 1, y: 0 }, SPRING);
            };
          });
          press(el, function () {
            animate(el, { scale: 0.98 }, { duration: 0.12 });
            return function () {
              animate(el, { scale: 1 }, SPRING);
            };
          });
        }
      );

      Array.prototype.forEach.call(document.querySelectorAll('.card-wrapper'), function (el) {
        if (el.closest('header, form, cart-drawer')) return;
        hover(el, function () {
          animate(el, { y: -3 }, SPRING);
          return function () {
            animate(el, { y: 0 }, SPRING);
          };
        });
      });
    }

    Array.prototype.forEach.call(
      document.querySelectorAll('.image-with-text__media, .multicolumn-card__image-wrapper, .collage-card'),
      function (box) {
        var img = box.querySelector('img');
        if (!img) return;
        hover(box, function () {
          animate(img, { transform: 'scale(1.03)' }, { duration: 0.9, ease: EASE });
          return function () {
            animate(img, { transform: 'scale(1)' }, { duration: 0.9, ease: EASE });
          };
        });
      }
    );
  }

  /* ---------- Subtle hero parallax ---------- */
  function initParallax() {
    if (designMode || !scroll) return;
    var seen = [];
    Array.prototype.forEach.call(
      document.querySelectorAll('.banner__media img, [class*="hero"][class*="__media"] img'),
      function (img) {
        if (seen.indexOf(img) !== -1) return;
        seen.push(img);
        var box = img.closest('.banner__media, [class*="__media"]') || img.parentElement;
        var travel = isMobile.matches ? 2.5 : 5;
        scroll(
          animate(img, { y: [-travel + '%', travel + '%'] }, { ease: 'linear' }),
          { target: box, offset: ['start end', 'end start'] }
        );
      }
    );
  }

  /* ---------- Header scroll state ---------- */
  function initHeader() {
    var header = document.querySelector('.header-wrapper');
    if (!header) return;
    var scrolled = false;
    var ticking = false;

    function update() {
      ticking = false;
      var next = window.scrollY > 12;
      if (next === scrolled) return;
      scrolled = next;
      animate(
        header,
        { boxShadow: next ? '0 8px 24px -14px rgba(21, 21, 21, 0.28)' : '0 0 0 0 rgba(21, 21, 21, 0)' },
        { duration: 0.35, ease: 'easeOut' }
      );
    }

    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true }
    );
    update();
  }

  function start() {
    if (!designMode) {
      initReveals();
      initEndOfPageCatch();
    }
    ready();
    initHover();
    initParallax();
    initHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
